import React, { useState } from 'react';

import TitleAndDescription from '../../../scripts/components/common/description-component';
import RadioButtonsInput from '../../../scripts/components/common/inputs/radio-buttons-input';
import { resetMetadata } from '../../../scripts/components/settings/api/reset-metadata';

import TextInput from 'utils/components/text-input';

const RESET_EXTRACT_DATA_BY_MAP = {
  spotId: 'spot_id',
  conversationId: 'conversation_id'
};

const RESET_EXTRACT_DATA_OPTIONS = [
  { value: RESET_EXTRACT_DATA_BY_MAP.spotId, text: 'Spot id' },
  { value: RESET_EXTRACT_DATA_BY_MAP.conversationId, text: 'Conversation id' }
];

export const ResetExtractData = () => {
  const [spotId, setSpotId] = useState('');
  const [conversationId, setConversationId] = useState('');
  const [lastResetDate, setLastResetDate] = useState(null);
  const [resetExtractDataBy, setResetExtractDataBy] = useState(RESET_EXTRACT_DATA_OPTIONS[0].value);
  const [isLoading, setIsLoading] = useState(false);

  const onResetExtractData = async () => {
    setIsLoading(true);

    try {
      await resetMetadata({ spotId, conversationId });

      setLastResetDate(new Date().toString());
    } catch (err) {
      console.error(err);
    }

    setIsLoading(false);
  };

  const onResetExtractDataByChange = (resetExtractDataBy: string) => {
    setSpotId('');
    setConversationId('');

    setResetExtractDataBy(resetExtractDataBy);
  };

  return (
    <div className="system-admin-input">
      <TitleAndDescription
        title="Extract Data"
        description="Reset the Extract data for a specific spot or conversation"
      />
      <div className="reset-url-container">
        <RadioButtonsInput
          name="extract-data-by"
          title="Reset the Extract data by:"
          options={RESET_EXTRACT_DATA_OPTIONS}
          value={resetExtractDataBy}
          onChange={onResetExtractDataByChange}
        />

        {resetExtractDataBy === RESET_EXTRACT_DATA_BY_MAP.spotId && (
          <TextInput
            className="reset-url"
            value={spotId}
            onChange={setSpotId}
            size="regular"
            placeholder="Type a spot id..."
          />
        )}

        {resetExtractDataBy === RESET_EXTRACT_DATA_BY_MAP.conversationId && (
          <TextInput
            className="reset-url"
            value={conversationId}
            onChange={setConversationId}
            size="regular"
            placeholder="Type a conversation id..."
          />
        )}

        <button className="reset-all-button" onClick={onResetExtractData}>
          {isLoading ? <span className="spinner reset" /> : 'Reset Data'}
        </button>

        {lastResetDate && (
          <div className="reset-message">
            <span className="reset-date">
              <span className="middle-dot-after">Last reset for URL: {lastResetDate}</span>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
